import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import { toStatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export class ReportingRexDashboardRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const product: LegacyProductRex = 'rex'
    const statsScope = toStatsScope(uiScope)
    const stats = await this.makeStatsRequest(product, statsScope, period)

    return {
      product,
      uiScope,
      period,
      scopedData,
      ...stats,
    }
  }

  makeStatsRequest = (product: LegacyProductRex, scope: StatsScope, period: NormalizedInterval) => {
    const { studentEvents } = this

    return RSVP.hash({
      totalUsageOverTime: studentEvents.totalUsageOverTime(product, scope, period),
      courseProgressByGrade: studentEvents.courseProgressByGrade(product, 'my_lessons', scope, period),
      assessmentScores: studentEvents.assessmentScores(product, scope, period),
      lexileGrowth: studentEvents.lexileGrowth(product, scope, period),
      spellingCourseProgress: studentEvents.courseProgressByGrade(product, 'spelling', scope, period),
      workingAtGradeLevel: studentEvents.workingAtGradeLevel(product, scope, period),
      booksReadByGenre: studentEvents.booksReadByGenre(product, scope, period),
      booksReadByLevel: studentEvents.booksReadByLevel(product, scope, period),
      stadiumEvents: studentEvents.stadiumEvents(product, scope, period),
      awardsEarned: studentEvents.awardsEarned(product, scope, period),
    })
  }
}

export default ReportingRexDashboardRoute
